module.exports = __webpack_public_path__ + "img/album03_03.dab3bf16.jpg";